import {
    List, Upload, Grid, BookOpen, Layout, Briefcase, Inbox, Users
} from 'react-feather';

export const MENUITEMS = [
    // {
    //     title: 'Inicio', path: '/inicio', icon: Home, type: 'link', active: false
    // },
    /* {
        title: 'Unidades', icon: Truck, type: 'sub', badgeType: 'primary', active: false, children: [
            { path: '/top', title: 'Top de Unidades', type: 'link' },
            { path: '/unidades', title: 'Unidades', type: 'link' },
        ]
    },
    {
        title: 'Publicaciones', icon: MessageSquare, type: 'sub', badgeType: 'primary', active: false, children: [
            { path: '/publicaciones/articulos', title: 'Artículos', type: 'link' },
            { path: '/publicaciones/categorias', title: 'Categorías', type: 'link' },
        ]
    },
    {
        title: 'Cotizaciones', path: '/cotizaciones', icon: FileText, type: 'link', active: false
    },
    {
        title: 'Banners', path: '/banners', icon: Image, type: 'link', active: false
    },
    {
        title: 'Asesores', path: '/asesores', icon: User, type: 'link', active: false
    }, */
    {
        title: 'Estadisticas',
        path: '/estadisticas',
        icon: Inbox,
        type: 'link',
        active: false,
        permission: 'dashboard'
    },
    {
        title: 'Cotizaciones',
        path: '/buzon',
        icon: Inbox,
        type: 'link',
        active: false,
        permission: 'cotizaciones'
    },
    {
        title: 'Clientes',
        path: '/clientes',
        icon: Briefcase,
        type: 'link',
        active: false,
        permission: 'clientes'
    },
    {
        title: 'Productos',
        path: '/productos',
        icon: List,
        type: 'link',
        active: false,
        permission: 'productos'
    },
    /* {
        title: 'Cargar productos', path: '/subida', icon: Upload, type: 'link', active: false
    }, */
    {
        title: 'Grupo',
        path: '/grupo',
        icon: Grid,
        type: 'link',
        active: false,
        permissions: ['departamentos', 'subdepartamentos', 'marcas', 'niveles', 'unidades']
    },
    {
        title: 'Sucursales',
        path: '/sucursales',
        icon: Inbox,
        type: 'link',
        active: false,
        permission: 'sucursales'
    },
    /* {
        title: 'Blog', path: '/publicaciones', icon: BookOpen, type: 'link', active: false
    }, */
/*     {
        title: 'Publicaciones', icon: BookOpen, type: 'sub', badgeType: 'primary', active: false, children: [
            { path: '/publicaciones', title: 'Artículos', type: 'link' },
            { path: '/categorias', title: 'Categorías', type: 'link' },
            // { path: '/thermo', title: 'Thermo', type: 'link' },
        ]
    }, */
    /* {
        title: 'Bolsa de Trabajo', path: '/bolsa', icon: Briefcase, type: 'link', active: false
    }, */
    {
        title: 'Usuarios',
        path: '/usuarios',
        icon: Users,
        type: 'link',
        active: false,
        permission: 'usuarios'
    },
    /* {
        title: 'Pantógrafo', path: '/pantografo', icon: Inbox, type: 'link', active: false
    }, */
    {
        title: 'Banners',
        path: '/sitio',
        icon: Layout,
        type: 'link',
        active: false,
        permission: 'banners'
    },
    /* {
        title: 'Preguntas', path: '/preguntas', icon: MessageSquare, type: 'link', active: false
    },
    {
        title: 'Categorías', path: '/categorias', icon: List, type: 'link', active: false
    },
    {
        title: 'Ubicaciones', path: '/ubicaciones', icon: MapPin, type: 'link', active: false
    }, */
    
    // {
    //     title: 'Configuración', path: '/configuracion', icon: Settings, type: 'link', active: false
    // }
]
